// Portal-unique localStorage namespace. seller-web, investor-web, and admin-web
// can share an origin (e.g. localhost:5001 during dev, or a common host in
// prod), so every persisted key is prefixed to guarantee no portal ever reads
// or clears another portal's session. Never use a bare, unprefixed key here.
export const STORAGE_NAMESPACE = 'seller_web'

export const AUTH_STORAGE_KEYS = {
  TOKEN: `${STORAGE_NAMESPACE}:auth_token`,
  REFRESH_TOKEN: `${STORAGE_NAMESPACE}:auth_refresh_token`,
} as const
